<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { defineProps } from 'vue';
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'chi-square-table-2';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.chi-square-table-2 {
  $height: 48px;
  $padding: 4px;
  --header-cell-height: #{$height};
  --body-cell-height: #{$height};
  $border: 1pt solid #c0bec7;
  thead {
    tr {
      border-bottom: 2pt solid var(--theme-color-1);
      &:first-child {
        th {
          & > div {
            padding: 0 24px;
          }
        }
      }
      &:nth-child(2):has(th[rowspan='1']) {
        border-bottom-width: 1pt;
      }
      &:not(:first-child) {
        border-left: $border;
        border-right: $border;
      }
    }
  }
  tbody {
    tr {
      td {
        & > div {
          font-size: 14px;
        }
        &:first-child {
          border-left: $border;
        }
        &:last-child {
          border-right: $border;
        }
      }
      &:first-child,
      &:nth-last-child(2),
      &:has(td:nth-child(2).empty) {
        --body-cell-height: #{$height + $padding};
      }
      &:first-child {
        td {
          padding-top: $padding;
        }
      }
      &:nth-last-child(2) {
        td {
          padding-bottom: $padding;
        }
      }
      &:has(td:nth-child(2).empty) {
        border-top: $border;
        border-bottom: 2pt solid var(--theme-color-1);
        td {
          padding-top: $padding;
        }
      }
    }
  }
}
</style>
